import { render, staticRenderFns } from "./collectionDetail.vue?vue&type=template&id=1f84b408&scoped=true"
import script from "./collectionDetail.vue?vue&type=script&lang=js"
export * from "./collectionDetail.vue?vue&type=script&lang=js"
import style0 from "./collectionDetail.vue?vue&type=style&index=0&id=1f84b408&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f84b408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f84b408')) {
      api.createRecord('1f84b408', component.options)
    } else {
      api.reload('1f84b408', component.options)
    }
    module.hot.accept("./collectionDetail.vue?vue&type=template&id=1f84b408&scoped=true", function () {
      api.rerender('1f84b408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/billCollection/cmp/collectionDetail.vue"
export default component.exports